/**
 * Score → band mapping for REPORT page sticky banner (matrix rows).
 * Band → message-id maps live in `stickyBannerMessages.js` (`REPORT_SCORE_SCROLL_MATRIX`,
 * `MATHS_OLYMPIAD_SCORE_SCROLL_MATRIX`).
 * Bands (accuracy % of overall score):
 * - Perfect: 100%
 * - High: strictly greater than 90% and below 100%
 * - Mid/Low: at most 90%
 * - Fallback: missing / non-finite score input
 *
 * `PERFECT_SCORE_EPS` treats float noise from (marks/max)×100 as full marks only near 100.
 */

export const SCORE_BAND_IDS = {
  PERFECT: "perfectScore",
  HIGH: "highScore",
  /** Former mid + low bands — single messaging tier */
  MEDIUM_LOW: "mediumLowScore",
  /** Invalid / missing overall score — dedicated fallback copy */
  FALLBACK: "fallbackBand"
};

/** Only treat as perfect when at (or effectively at) 100% — not high-90s */
const PERFECT_SCORE_EPS = 1e-9;

/**
 * @param {number|null|undefined} scorePercent
 * @returns {string} SCORE_BAND_IDS value (including `fallbackBand` when unusable)
 */
export function resolveScoreBandId(scorePercent) {
  if (scorePercent == null || !Number.isFinite(scorePercent)) {
    return SCORE_BAND_IDS.FALLBACK;
  }
  const p = Math.min(100, Math.max(0, scorePercent));
  if (p >= 100 - PERFECT_SCORE_EPS) {
    return SCORE_BAND_IDS.PERFECT;
  }
  if (p >= 90) {
    return SCORE_BAND_IDS.HIGH;
  }
  if (p < 90) {
    return SCORE_BAND_IDS.MEDIUM_LOW;
  }
  return SCORE_BAND_IDS.FALLBACK;
}
